import * as React from "react";
import { Container, Heading } from "@grandvisionhq/elements";
import { ProductListingGallery } from "@grandvisionhq/products";
/* empty css                              */
const AlgoliaCrossSellProducts = ({
  title,
  result,
  isLoading,
  handleImpression,
  handleInteraction
}) => {
  const productSkus = React.useMemo(
    () => result.map((product) => product.masterVariant.sku),
    [result]
  );
  return /* @__PURE__ */ React.createElement("div", { className: "cross-sell-products", "data-t": "cross-sell-products" }, /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(Heading, { component: "h2", variant: "medium" }, title), /* @__PURE__ */ React.createElement(
    ProductListingGallery,
    {
      skus: productSkus,
      products: result,
      isLoading,
      hasError: false,
      onProductImpression: handleImpression,
      onProductInteraction: handleInteraction,
      productLocation: "crossSell",
      shouldSendTealiumEvent: true
    }
  )));
};
export {
  AlgoliaCrossSellProducts,
  AlgoliaCrossSellProducts as default
};
//# sourceMappingURL=AlgoliaCrossSellProducts.js.map
